import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {AirIndicators} from "@types-custom/models/ui/air_quality/air-quality-modal.model";

@Component({
  selector: "sit-air-quality-indicators",
  templateUrl: "./air-quality-indicators.component.html",
  styleUrls: ["./air-quality-indicators.component.scss"],
})
export class AirQualityIndicatorsComponent implements OnInit{
  @Input()  properties          : AirIndicators;
  @Input()  active              = false;
  @Output() IndicatorDispatcher : EventEmitter<AirIndicators> = new EventEmitter<AirIndicators>;

  ngOnInit() {
    return;
  }

  public SelectIndicator(item : AirIndicators) {
    this.IndicatorDispatcher.emit(item);
  }

  public DefineColor(value: string) {
    const numberValue = Number(value)


    if (this.properties.ranges.length > 0) {
      const color = this.properties.ranges.find(range => numberValue >= range.minValue && numberValue <= range.maxValue)?.color || '#9A00FF';

      return color;
    }

    return undefined;
    // Buena                        1-10    #00FFFF
    // Razonablemente Buena         11-20   #00B050
    // Regular                      21-30   #FFCC00
    // Desfavorable                 31-40   #FF3300
    // Muy Desfavorable             41-50   #9A0000
    // Extremadamente desfavorable  51-60   #9A00FF

  }
}
